import React, { useRef } from 'react'
import { Form, Radio, Input } from 'antd'
import Heading from 'components/shared/Heading'
import OrderNavigation from 'components/shared/OrderNavigation'
import Checkbox from 'components/shared/Checkbox'
import {
  photographerKeyInstructionPrefix,
  photographerKeyInstructionRegex,
} from 'components/PrivateRoutes/NewOrder/ProductSelection/helpers'
import './index.scss'

function pickUpKeysChanged(previousValues, currentValues) {
  return previousValues.pickUpKeys !== currentValues.pickUpKeys
}

function showPickUpKeysInstructions(getFieldValue) {
  return ['keybox'].includes(getFieldValue('pickUpKeys'))
}

const InformationForm = ({
  productSelection,
  handleSubmit,
  goToPreviousStep,
}) => {
  const messageForPhotographerInput = useRef(null)
  const [form] = Form.useForm()

  function onFinish(values) {
    handleSubmit({
      pickUpKeysInstructions: null, // Reset this field if not shown
      ...values,
    })
  }

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={productSelection}
      onFinish={onFinish}
      scrollToFirstError
      className="estate-information-form"
    >
      <Heading level={3}>Hastelevering</Heading>
      <div className="section">
        <Form.Item name="expressDelivery" valuePropName="checked">
          <Checkbox
            label="Fotoprodukter"
            description="Hastelevering leveres innen kl 2000 samme dag, og må bookes før kl 1400. Ekstra kostnad tilkommer"
          >
            Fotoprodukter
          </Checkbox>
        </Form.Item>
      </div>

      <Heading level={3}>Tilgang til objektet</Heading>
      <div className="section">
        <Form.Item noStyle shouldUpdate={true}>
          {({ getFieldValue, setFieldsValue }) => {
            return (
              <Form.Item name="pickUpKeys">
                <Radio.Group>
                  <Radio value="false">Noen er tilstede</Radio>
                  <Radio value="true">Hent nøkkel på meglerkontor</Radio>
                  <Radio value="keybox">Nøkkelboks</Radio>
                  <Radio
                    value="other"
                    onChange={() => {
                      const prevMessage = getFieldValue(
                        'messageForPhotographer'
                      )
                      if (!photographerKeyInstructionRegex.test(prevMessage)) {
                        setFieldsValue({
                          messageForPhotographer: `${
                            prevMessage ? `${prevMessage} ` : ''
                          }${photographerKeyInstructionPrefix}`,
                        })
                      }
                      messageForPhotographerInput.current.focus()
                    }}
                  >
                    Annet - melding til fotograf
                  </Radio>
                </Radio.Group>
              </Form.Item>
            )
          }}
        </Form.Item>

        <Form.Item noStyle shouldUpdate={pickUpKeysChanged}>
          {({ getFieldValue }) => {
            if (showPickUpKeysInstructions(getFieldValue)) {
              return (
                <Form.Item
                  name="pickUpKeysInstructions"
                  className="pick-up-keys-instructions"
                  rules={[
                    {
                      required: true,
                      message: 'Beskrivelse er påkrevd',
                    },
                  ]}
                >
                  <Input
                    placeholder={
                      getFieldValue('pickUpKeys') === 'keybox'
                        ? 'F.eks kode til nøkkelboks'
                        : 'F.eks hvor nøkkelen finnes'
                    }
                  />
                </Form.Item>
              )
            }
          }}
        </Form.Item>
      </div>

      <Heading level={3}>Boliginformasjon</Heading>
      <div className="section">
        <Form.Item
          name="estateAddressDoorbell"
          colon={false}
          label="Navn på ringeklokke"
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="additionalEstateAddressInfo"
          colon={false}
          label="Annet - oppgang, parkering"
        >
          <Input />
        </Form.Item>
      </div>

      <Heading level={3}>Til fotograf</Heading>
      <div className="section">
        <Form.Item
          name="messageForPhotographer"
          colon={false}
          label="Melding til fotograf"
        >
          <Input.TextArea
            autosize={{ minRows: 2, maxRows: 6 }}
            placeholder="F.eks spesielle ønsker til bildemotiver og instrukser for tilgang til objektet"
            ref={messageForPhotographerInput}
          />
        </Form.Item>
      </div>

      <Heading level={3}>Kommentar til bestilling</Heading>
      <div className="section">
        <Form.Item
          name="messageForCustomerService"
          colon={false}
          label="Melding til kundeservice"
        >
          <Input.TextArea
            autosize={{ minRows: 2, maxRows: 6 }}
            placeholder="F.eks spesielle ønsker til bildemotiver"
          />
        </Form.Item>
      </div>

      <OrderNavigation
        onBack={goToPreviousStep}
        nextButtonProps={{
          htmlType: 'submit',
        }}
      />
    </Form>
  )
}

const Information = ({
  productSelection,
  productSelectionReducer,
  goToNextStep,
  goToPreviousStep,
}) => {
  const onProceed = (information) => {
    productSelectionReducer({ type: 'setInformation', information })
    goToNextStep()
  }

  return (
    <div className="new-order information">
      <Heading level={2}>Oppdragsinformasjon</Heading>

      <InformationForm
        productSelection={productSelection}
        handleSubmit={onProceed}
        goToPreviousStep={goToPreviousStep}
      />
    </div>
  )
}

export default Information
